import { IApplicationContext } from 'shared/common/types/applicationContext';
import { TFetchFormParams } from 'shared/common/types/form';
import { TSendFormResponse } from './types';

export async function fetchCallbackForm({ httpApi }: IApplicationContext, params: TFetchFormParams) {
  const response = await httpApi.fetch(
    {
      apiType: 'external',
      microserviceName: 'my-external-api',
      assertStatusCodes: [200, 400, 500],
      method: 'POST',
      pathApi: '/api/sob/v1/save-form-request',
      parameters: params,
    },
    {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
      },
    },
  );

  return response as TSendFormResponse;
}
